import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bde63052"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialogvisible-content" }
const _hoisted_2 = { class: "content-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-th" }, [
  /*#__PURE__*/_createElementVNode("span", null, "姓名/账户"),
  /*#__PURE__*/_createElementVNode("span", null, "成交/委托股"),
  /*#__PURE__*/_createElementVNode("span", null, "状态")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-info" }, "未成交部分将全部撤单", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.dialogVisible,
    title: "一键撤单确认",
    width: "600px",
    "before-close": _ctx.handleClose,
    "destroy-on-close": "",
    center: "",
    "show-close": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "content-close",
        onClick: _withModifiers(_ctx.handleClose, ["stop"])
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        class: "content-confirm",
        type: "primary",
        onClick: _withModifiers(_ctx.cancelOrder, ["stop"]),
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_scrollbar, { class: "scroll-wrapper" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.subOrders, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "table-th table-tb",
                  key: item
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.nameCn) + "(" + _toDisplayString(item.fundAccount) + ")", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.numFormat(Number(item.businessAmount), 0)) + "/" + _toDisplayString(_ctx.numFormat(Number(item.entrustAmount), 0)), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.STATES[item.entrustStatus]), 1)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ])), [
          [_directive_loading, _ctx.contentLoading]
        ]),
        _hoisted_4
      ])
    ]),
    _: 1
  }, 8, ["model-value", "before-close"]))
}